import { DraftState } from '@/types';

export const setValidationErrorFlag = (draft: DraftState) => {
  draft.validation.valid = !draft.configurationIds.some((cid) => {
    if (draft.validation.errors[cid]) {
      return Object.values(draft.validation.errors[cid]).some((errorValue) => Boolean(errorValue));
    }
    return false;
  });
  return draft;
};
